import type { ReactNode } from 'react';
import type { ClientSnapshot } from '@lw/client-core';
import { useRuntime } from '../runtime/useRuntime.js';
import { actedBy, fmtTime } from '../app/helpers.js';
import { ActedBy, EstimateChip, ReadyAge, SolutionSummary } from '../components/Chips.js';
import { CountdownPanel } from '../components/Countdown.js';
import { ReviewCard } from '../components/Common.js';
import type { ViewOut } from './UavView.js';

export function ObserverView({ snapshot: s }: { snapshot: ClientSnapshot }): ViewOut {
  const { state } = useRuntime();
  const events = state.events;
  const mirror = (eyebrow: string, title: string, extra?: ReactNode): ViewOut => ({ main: <div className="card"><div className="eyebrow">{eyebrow}</div><h2 className="big">{title}</h2>{extra}</div> });
  switch (s.state) {
    case 'CFF': return mirror('Call for fire', s.target?.value ?? '—', <><p>Awaiting the FDC.</p><ActedBy by={actedBy(events, 'CFF_CREATED')} /></>);
    case 'SOLUTION': return mirror('Solution', 'FDC computing solution', <div className="row" style={{ marginTop: 10 }}><EstimateChip /></div>);
    case 'PROGRAMMING': return mirror('Programming', `Shell code ${s.solution?.laserCode ?? ''}`, <div className="row" style={{ marginTop: 10 }}><EstimateChip /></div>);
    case 'LOADING': return mirror('Loading', 'Gun being loaded', <><div className="row" style={{ marginTop: 10 }}><EstimateChip /></div><SolutionSummary /></>);
    case 'WEAPON_READY': return mirror('Weapon ready', 'Awaiting UAV', <SolutionSummary />);
    case 'UAV_READY': return mirror('UAV ready', 'Awaiting shot', <><p>Ready for <ReadyAge />.</p><SolutionSummary /></>);
    case 'FIRE_REVIEW': return { main: <ReviewCard snapshot={s} forFdc={false} /> };
    case 'IN_FLIGHT': return { main: <CountdownPanel snapshot={s} /> };
    case 'AWAITING_DISPOSITION': return mirror('Mission complete', `Impact ${fmtTime(s.timeline?.tImpact, true)}`, <p>{s.uav.laserOffAt ? 'Laser off confirmed.' : 'Awaiting LASER OFF.'} The UAV is saving or discarding the log.</p>);
    default: return { main: null };
  }
}
